import { render, staticRenderFns } from "./RedirectView.vue?vue&type=template&id=a081ef2a"
import script from "./RedirectView.ts?vue&type=script&lang=ts&external"
export * from "./RedirectView.ts?vue&type=script&lang=ts&external"
import style0 from "./RedirectView.vue?vue&type=style&index=0&id=a081ef2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports